









import {Component, Vue} from "vue-property-decorator";

@Component({
    name: 'ProfileIcon'
})
export default class ProfileIcon extends Vue {
    get initials(): string {
        return this.$store.state.session.profile && this.$store.state.session.profile.initials;
    }
    get hasAvatar(): boolean {
        return !!this.$store.state.session?.profile?.photoFileId;
    }
    get avatarPath(): string {
        return this.$store.state.session?.profile?.profilePhotoLink?.(this.$store.state.session.backend) || '';
    }

    onClick() {
        this.$emit('settings-click');
    }
}
